import { FC, useState, useEffect } from 'react';
import useAzureBlobImages from '../../hooks/useAzureBlobImages';
import { Skeleton } from 'primereact/skeleton';

interface ProductImageProps {
  code: string;
  alt: string;
  onClick: (url: string) => void;
  onImageLoad?: (code: string, url: string) => void;
}

export const ProductImage: FC<ProductImageProps> = ({
  code,
  alt,
  onClick,
  onImageLoad,
}) => {
  const { image, loading } = useAzureBlobImages(code);
  const [imgSrc, setImgSrc] = useState('/placeholder.jpg');

  useEffect(() => {
    if (!loading && image && image.url) {
      setImgSrc(image.url);
      onImageLoad?.(code, image.url);
    }
  }, [loading, image, code, onImageLoad]);

  if (loading) {
    return (
      <div
        style={{
          height: '50px',
          width: '50px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton width="100%" height="50px" className="gray-skeleton" />
      </div>
    );
  }

  return (
    <img
      style={{
        height: '50px',
        width: 'auto',
        cursor: 'pointer',
      }}
      src={imgSrc}
      alt={alt}
      onClick={() => onClick(imgSrc)}
    />
  );
};
